// services/contactsService.js
import axios from "axios";
import { detectPeriodeDominante } from "../utils/periodeDominante.js";

/**
 * Récupère les contacts d'un groupe et calcule la période dominante.
 * @param {string} groupeId - ID du groupe
 * @returns {Promise<{contactsValid: Array, filteredContacts: Array, periodeDominante: string}>}
 */

export async function fetchContactsByGroupe(groupeId) {
  try {
    if (!groupeId) {
      console.warn("⚠️ Aucun groupeId fourni à fetchContactsByGroupe");
      return { contactsValid: [], filteredContacts: [], periodeDominante: "" };
    }

    // Appel API pour récupérer les contacts
    const res = await axios.get(`${process.env.REACT_APP_API}/groupes/${groupeId}/contacts`);

    // On s'assure que c'est bien un tableau
    const contactsValid = Array.isArray(res.data) ? res.data : [];

    // Détection de la période dominante
    const periodeDominante = detectPeriodeDominante(contactsValid) || "";

    // Filtrage selon la période dominante
    const filteredContacts = periodeDominante
      /*? contactsValid.filter(c => c.periode === periodeDominante)*/
      ? contactsValid.filter(c => c[periodeDominante]) // accès dynamique à la clé
      : contactsValid;

    return { contactsValid, filteredContacts, periodeDominante };
    
  } catch (err) {
    console.error("❌ Erreur fetchContactsByGroupe :", err);
    // Toujours retourner un objet complet pour éviter les undefined
    return { contactsValid: [], filteredContacts: [], periodeDominante: "" };
  }
}
